import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=58ab0286&scoped=true&"
import script from "./Example.vue?vue&type=script&lang=ts&"
export * from "./Example.vue?vue&type=script&lang=ts&"
import style0 from "./Example.vue?vue&type=style&index=0&id=58ab0286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab0286",
  null
  
)

export default component.exports